import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-white border-t py-4 absolute bottom-0 left-0 right-0">
      <div className="max-w-xl mx-auto px-4 text-center">
        <div className="powered-by text-sm text-gray-500">
          <span>Сервис онлайн-записи</span>
          <a 
            href="https://eazy.pet/" 
            className="easypet-link text-primary hover:text-primary/90 ml-1 font-medium"
            target="_blank"
            rel="noopener noreferrer"
          >
            EasyPet
          </a>
        </div>
      </div>
    </footer>
  );
} 